import React, { createContext, useEffect, useReducer } from 'react'

import { analytics, constants } from 'helpers'
import { useLogin, useLogout } from 'hooks'

const AuthStateContext = createContext()
const AuthDispatchContext = createContext()

const {
  AUTH_ACTIONS: { LOGIN, LOGGING, LOGOUT, UPDATE_USER, PARTIAL_UPDATE_USER },
  AUTH_STATUS: { LOGGING_IN, LOGGED_IN, LOGGED_OUT },
} = constants

export const initialState = {
  user: null,
  status: LOGGING_IN,
}

export const AuthReducer = (state, action) => {
  switch (action.type) {
    case LOGIN:
      return {
        user: action.payload,
        status: LOGGED_IN,
      }
    case UPDATE_USER:
      return { user: action.payload, status: LOGGED_IN }
    case PARTIAL_UPDATE_USER:
      return { user: { ...state.user, ...action.payload }, status: LOGGED_IN }
    case LOGOUT:
      return {
        user: null,
        status: LOGGED_OUT,
      }
    case LOGGING:
      return {
        user: null,
        status: LOGGING_IN,
      }
    default:
      throw new Error(`Unhandled action type: ${action.type}`)
  }
}

const InternalAuthProvider = ({ children }) => {
  const login = useLogin()
  const logout = useLogout()

  useEffect(() => {
    const chatToken = localStorage.getItem('chatToken')
    const jwt = localStorage.getItem('token')
    const userId = localStorage.getItem('userId')
    if (chatToken && jwt && userId) {
      analytics.segmentTrack('User Logged In Automatically As Have Previous Session')
      login({ chatToken, jwt, userId }).catch(logout)
    } else {
      logout()
    }
  }, [login, logout])

  return children
}

const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AuthReducer, initialState)

  return (
    <AuthStateContext.Provider value={state}>
      <AuthDispatchContext.Provider value={dispatch}>
        <InternalAuthProvider dispatch={dispatch}>{children}</InternalAuthProvider>
      </AuthDispatchContext.Provider>
    </AuthStateContext.Provider>
  )
}

export { AuthProvider, AuthStateContext, AuthDispatchContext }
